import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'services/user/types';
import { ThunkGetUser } from 'store/user/thunks';
import { RootState } from 'store/index';
import { TOKEN, REFRESH_TOKEN, USER_ID } from 'constants/localStorage';

const initialState: Partial<IUser> = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearStore: state => {
      localStorage.removeItem(TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(USER_ID);
      return {};
    },
  },
  extraReducers: builder => {
    builder.addCase(ThunkGetUser.fulfilled, (_, action) => {
      return action.payload;
    });
  },
});

export default userSlice.reducer;

export const { clearStore } = userSlice.actions;
export const UserDataSelector = (state: RootState): Partial<IUser> => state.user;
